import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';

// Rango por defecto del informe de presencia: nunca incluye el día en curso.
// - Lunes: la semana anterior completa (lunes a domingo).
// - Resto de días: del lunes de esta semana hasta ayer.
export function defaultPresenceReportRange(now = moment()) {
  const today = moment(now).startOf('day');
  const isMonday = today.isoWeekday() === 1;
  const monday = today.clone().isoWeekday(1);
  const from = isMonday ? monday.clone().subtract(7, 'day') : monday;
  const to = isMonday ? from.clone().add(6, 'day') : today.clone().subtract(1, 'day');
  return [from.format(DATE_FORMAT), to.format(DATE_FORMAT)];
}
